<div class="lock-container" *ngIf="showRequestAccess">
  <mat-icon svgIcon="lock-profile" data-cy="generic-no-access-icon" />
  <div class="notification-message" data-cy="generic-no-access-message">
    {{ 'page.locked.notification.request.message' | translate }}
  </div>

  <div
    class="notification-button"
    data-cy="generic-no-access-button"
    (click)="requestVesselAccess()">
    {{ 'page.locked.notification.request.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showAccessRequested">
  <mat-icon svgIcon="lock-profile" data-cy="generic-pending-access-icon" />
  <div class="notification-message" data-cy="generic-pending-access-message">
    {{ 'page.locked.notification.requested.message' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showAccessAccepted">
  <mat-icon svgIcon="lock-clock" />
  <div class="notification-message">
    {{ 'page.locked.notification.accepted.message' | translate: { owner: ownerName } }}
  </div>
  <div class="notification-button" (click)="startEdit()">
    {{ 'page.locked.notification.accepted.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showAccessRemoved">
  <mat-icon svgIcon="lock" />
  <div class="notification-message">
    {{ 'page.locked.notification.removed.message' | translate }}
  </div>
  <div class="notification-button" (click)="showAccessRemovedDialog()">
    {{ 'page.locked.notification.removed.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showAccessRejected">
  <mat-icon svgIcon="lock" />
  <div class="notification-message" data-cy="generic-rejected-access-message">
    {{ 'page.locked.notification.rejected.message' | translate }}
  </div>

    <div 
        class="notification-button" 
        data-cy="generic-rejected-access-button" 
        (click)="closeRejectedMessage()">
        {{ 'page.locked.notification.rejected.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showVesselInReview">
  <mat-icon svgIcon="pending-approval" />
  <div class="notification-message">
    {{ 'page.locked.notification.pending.message' | translate: { pageName: pageName } }}
  </div>
</div>

<div class="lock-container" *ngIf="showVesselApproved">
  <mat-icon svgIcon="spaceship" />
  <div class="notification-message">
    {{ 'page.locked.notification.approved.message' | translate: { pageName: pageName } }}
  </div>
</div>

<div class="lock-container" *ngIf="isVesselUnassigned">
  <mat-icon svgIcon="unlocked" />
  <div class="notification-message">
    {{ 'page.locked.notification.unassigned-vessel.message' | translate }}
  </div>
  <div class="notification-button" (click)="claimOwnership()">
    {{ 'page.locked.notification.claim.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="vesselNeedsNewVersion">
  <mat-icon svgIcon="no-file" />
  <div class="notification-message">
    {{ 'page.locked.notification.start-new-version.message' | translate }}
  </div>
  <div class="notification-button" (click)="goBackToVessel()">
    {{ 'page.locked.notification.go-back-vessel.button' | translate }}
  </div>
</div>

<app-confirmation-window
  #claimOwnershipConfirmationDialog
  [mainLabel]="'vessel.page.message.ownership.claim.dialog.title'"
  [subLabel]="'vessel.page.message.ownership.claim.dialog.message'"
  [discardLabel]="'vessel.page.message.ownership.claim.dialog.cancel'"
  [saveLabel]="'vessel.page.message.ownership.claim.dialog.claim'"
  [allButtonsLeft]="true"></app-confirmation-window>
